import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppProvider } from './utils/AppContext';
import ErrorBoundary from './components/ErrorBoundary';
import Dashboard from './components/Dashboard';
import ConfigPanel from './components/ConfigPanel';
import TimerPage from './pages/TimerPage';
import BracketPage from './pages/BracketPage';
import LeaderboardPage from './pages/LeaderboardPage';
import CarouselPage from './pages/CarouselPage';
import PodiumSlideshowPage from './pages/PodiumSlideshowPage';
import PizarraPage from './pages/PizarraPage';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AppProvider>
          <div className="App">
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/" element={
                <div>
                  <Dashboard />
                  <ConfigPanel />
                </div>
              } />
              <Route path="/timer" element={<TimerPage />} />
              <Route path="/bracket" element={<BracketPage />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/carousel" element={<CarouselPage />} />
              <Route path="/podium" element={<PodiumSlideshowPage />} />
              <Route path="/pizarra" element={<PizarraPage />} />
            </Routes>
          </div>
        </AppProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
